import {ENDPOINTS} from 'general/constants';
import {getVisitorId, logWithSentry} from 'sentry/sentry';
import type {AxiosInstance} from 'axios';

type ParamsType = {
    instance: AxiosInstance;
    email: string;
    gender: string;
    storeId: number;
};
/**
 * send gender information to Cordial
 * @param {AxiosInstance} instance - instance for correct request
 * @param {string} email - user's email
 * @param {string} gender - user's gender
 * @param {string} storeId - store id
 */
export const sendGenderToCordial = ({instance, email, gender, storeId}: ParamsType) => {
    const visitorId = getVisitorId();
    instance
        .post(
            `${ENDPOINTS.SET_GENDER_IN_CORDIAL}`,
            {
                storeId,
                visitorId,
                eventType: 'genderChosen',
                eventData: {
                    email,
                    gender,
                },
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        )
        .catch(error => logWithSentry(error as Error));
};
